import * as React from 'react';
import React__default from 'react';
import Slider from 'react-slick';
import clsx from 'clsx';
import { Icon } from '@wartek-id/icon';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".Carousel-module_carousel__CzyVe .slick-slide div a{color:var(--color-text-default);outline:none}.Carousel-module_carousel__CzyVe .slick-slide{height:auto}.Carousel-module_carousel__CzyVe .slick-slide>div{margin-bottom:-.4rem}.Carousel-module_dots__1rx1z{bottom:1rem;list-style:none;max-width:100%;padding:0 40px;position:absolute;text-align:center;width:100%;width:var(--size-slider-dots-width)}.Carousel-module_dots__1rx1z li{cursor:pointer;display:inline-block;height:12px;margin:0 4px;outline:none;position:relative;width:12px}.Carousel-module_dots__1rx1z li button{background-color:transparent;border:1px solid var(--color-border-subdued);border-radius:50%;color:transparent;cursor:pointer;display:block;font-size:0;line-height:0;outline:none;padding:5px;transition:all .3s cubic-bezier(.4,0,.2,1)}.Carousel-module_dots__1rx1z.Carousel-module_dark__cQAaI li button{border:1px solid var(--color-border-default)}.Carousel-module_dots__1rx1z.Carousel-module_light__NDgVh li button{border:1px solid var(--color-border-subdued)}.Carousel-module_dots__1rx1z li.slick-active button{background-color:var(--color-interactive-default)}.Carousel-module_dots__1rx1z li button:hover{border:1px solid var(--color-interactive-focused)}.Carousel-module_dots__1rx1z li button:focus{box-shadow:0 0 0 2px var(--color-interactive-focused)}.Carousel-module_dots__1rx1z li button:focus,.Carousel-module_dots__1rx1z li button:hover{outline:none}.Carousel-module_slickNext__JimUv,.Carousel-module_slickPrev__D7WjP{border:none;bottom:5px;cursor:pointer;display:block;font-size:0;height:20px;line-height:0;padding:0;position:absolute;transform:translateY(-50%);width:20px;z-index:1}.Carousel-module_slickNext__JimUv{right:10px;right:calc(100% - var(--size-slider-dots-width) + 5px)}.Carousel-module_slickNext__JimUv:disabled,.Carousel-module_slickPrev__D7WjP:disabled{cursor:none;opacity:.3}";
var styles = {"carousel":"Carousel-module_carousel__CzyVe","dots":"Carousel-module_dots__1rx1z","dark":"Carousel-module_dark__cQAaI","light":"Carousel-module_light__NDgVh","slickNext":"Carousel-module_slickNext__JimUv","slickPrev":"Carousel-module_slickPrev__D7WjP"};
styleInject(css_248z$1);

var CarouselArrow = function (props) {
    var className = props.className, style = props.style, onClick = props.onClick, onArrowClick = props.onArrowClick;
    return (React__default.createElement("button", { className: clsx(props.type === 'next' ? styles.slickNext : styles.slickPrev, className), style: style, disabled: className === null || className === void 0 ? void 0 : className.includes('slick-disabled'), onClick: function () {
            if (onArrowClick)
                onArrowClick();
            if (onClick)
                onClick();
        }, "data-testid": "carousel-arrow-".concat(props.type), "aria-label": props.type === 'prev' ? 'Slide sebelumnya' : 'Slide selanjutnya' }, props.type === 'next' ? (React__default.createElement(Icon, null, "chevron_right")) : (React__default.createElement(Icon, null, "chevron_left"))));
};

var css_248z = ".slick-slider{-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;box-sizing:border-box;touch-action:pan-y;-webkit-user-select:none;-moz-user-select:none;user-select:none;-khtml-user-select:none}.slick-list,.slick-slider{display:block;position:relative}.slick-list{margin:0;overflow:hidden;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{transform:translateZ(0)}.slick-track{display:block;left:0;margin-left:auto;margin-right:auto;position:relative;top:0}.slick-track:after,.slick-track:before{content:\"\";display:table}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{border:1px solid transparent;display:block;height:auto}.slick-arrow.slick-hidden{display:none}";
styleInject(css_248z);

var Carousel = React.forwardRef(function (_a, ref) {
    var _b = _a.accessibility, accessibility = _b === void 0 ? true : _b, _c = _a.adaptiveHeight, adaptiveHeight = _c === void 0 ? true : _c, _d = _a.arrows, arrows = _d === void 0 ? false : _d, _e = _a.autoplay, autoplay = _e === void 0 ? false : _e, _f = _a.dots, dots = _f === void 0 ? true : _f, _g = _a.dotsColor, dotsColor = _g === void 0 ? 'light' : _g, _h = _a.dotsAutoWidth, dotsAutoWidth = _h === void 0 ? false : _h, children = _a.children, props = __rest(_a, ["accessibility", "adaptiveHeight", "arrows", "autoplay", "dots", "dotsColor", "dotsAutoWidth", "children"]);
    var slideLength = React.Children.count(children);
    // mengukur lebar elemen .dots berdasarkan jumlah item dalam daftar slide
    // * 20 -> setiap lebar titik adalah 20px
    // + 80 -> padding kiri dan kanan, masing-masing 40px (periksa di .dots css)
    var estimateDotsWidth = slideLength * 20 + 80;
    // mengukur lebar slider
    var sliderRef = React.useRef(null);
    var _j = React.useState(0), sliderWidth = _j[0], setSliderWidth = _j[1];
    React.useEffect(function () {
        if (sliderRef.current) {
            setSliderWidth(sliderRef.current.offsetWidth);
        }
    }, [sliderRef]);
    // menggunakan estimateDotsWidth jika dotsAutoWidth adalah true
    // dan kurang dari atau sama dengan sliderWidth sehingga panah kanan selalu terlihat
    var usedDotsWidth = dotsAutoWidth && slideLength > 0 && estimateDotsWidth <= sliderWidth
        ? "".concat(estimateDotsWidth, "px")
        : '100%';
    var dotsAutoWidthClass = dotsAutoWidth ? 'dots-auto-width' : '';
    var carouselSettings = __assign(__assign({ accessibility: accessibility, adaptiveHeight: adaptiveHeight, arrows: arrows, autoplay: autoplay, dots: dots }, props), { style: { '--size-slider-dots-width': usedDotsWidth }, dotsClass: clsx(styles.dots, styles[dotsColor], props.dotsClass, dotsAutoWidthClass), className: clsx(styles.carousel, props.className), prevArrow: (React.createElement(CarouselArrow, { type: "prev", onArrowClick: props.onPrevArrowClick })), nextArrow: (React.createElement(CarouselArrow, { type: "next", onArrowClick: props.onNextArrowClick })) });
    return (React.createElement("div", { ref: sliderRef },
        React.createElement(Slider, __assign({ ref: ref }, carouselSettings), children)));
});
Carousel.displayName = 'Carousel';

export { Carousel };
